/*******PRODUCCION*********/

export const environment = {
  production: true,
  baseUrl: 'https://registroventas.pactia.com/service/api/',
  baseUrlExterno: 'https://registroventas.pactia.com/service/',
  scopeUri: ['api://b425d7b3-518e-4577-a45d-ce2a8d99fcbf/RegistroVentasAPIProd'],
  tenantId: '6503c5d1-70bc-437f-a0b6-a7849af8c68c',
  uiClienId: '67585778-9a02-4897-b936-812a12e48d4b',
  redirectUrl: 'https://registroventas.pactia.com/site/#/home',
  userEmailLogged: '',
  userFullname: '',
  edificiosAutorizados: '',
  marcasAutorizadas: '',
  tipoUsuario: '',
  userSubscripciónId: 0,
  urlReporteCeco: 'https://app.powerbi.com/reportEmbed?reportId=7b092e8c-82c1-4684-b316-32d5a772a0ef&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
  urlReporteGeneral: 'https://app.powerbi.com/reportEmbed?reportId=d2f6c44a-2b63-4d09-8df9-61cb20e0ad54&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
  urlReporteGeografico:'https://app.powerbi.com/reportEmbed?reportId=6e1813d8-c134-4db1-8a4d-6c920b0fb04d&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
  apiBIUrl: 'https://pactiaapiconexionbi.azurewebsites.net/api/'
 };
 

/*******DESARROLLO SERVIDOR DATOS PROD*********/

// export const environment = {
//   production: true,
//   baseUrl: 'https://registroventas.pactia.com/service/api/',
//   baseUrlExterno: 'https://registroventas.pactia.com/service/',
//   scopeUri: ['api://0c5784f2-a624-4808-923c-a65d02a86894/APIResgistroVentas'],
//   tenantId: '6503c5d1-70bc-437f-a0b6-a7849af8c68c',
//   uiClienId: '108489c8-b1b2-45d5-b947-dfa31ae48a0b',
//   redirectUrl: 'http://localhost:4200/#/home',
//   userEmailLogged: '',
//   userFullname: '',
//   edificiosAutorizados: '',
//   marcasAutorizadas: '',
//   tipoUsuario: '',
//   userSubscripciónId: 0,
//   urlReporteCeco: 'https://app.powerbi.com/reportEmbed?reportId=7b092e8c-82c1-4684-b316-32d5a772a0ef&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   urlReporteGeneral: 'https://app.powerbi.com/reportEmbed?reportId=d2f6c44a-2b63-4d09-8df9-61cb20e0ad54&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   urlReporteGeografico:'https://app.powerbi.com/reportEmbed?reportId=6e1813d8-c134-4db1-8a4d-6c920b0fb04d&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   apiBIUrl: 'https://pactiaapiconexionbi.azurewebsites.net/api/',
// };

/*******DESARROLLO SERVIDOR DATOS DEV*********/

// export const environment = {
//   production: true,
//   baseUrl: 'https://localhost:5001/api/',
//   baseUrlExterno: 'https://localhost:5001/',
//   scopeUri: ['api://0c5784f2-a624-4808-923c-a65d02a86894/APIResgistroVentas'],
//   tenantId: '6503c5d1-70bc-437f-a0b6-a7849af8c68c',
//   uiClienId: '108489c8-b1b2-45d5-b947-dfa31ae48a0b',
//   redirectUrl: 'http://localhost:4200/#/home',
//   userEmailLogged: '',
//   userFullname: '',
//   edificiosAutorizados: '',
//   marcasAutorizadas: '',
//   tipoUsuario: '',
//   userSubscripciónId: 0,
//   urlReporteCeco: 'https://app.powerbi.com/reportEmbed?reportId=7b092e8c-82c1-4684-b316-32d5a772a0ef&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   urlReporteGeneral: 'https://app.powerbi.com/reportEmbed?reportId=d2f6c44a-2b63-4d09-8df9-61cb20e0ad54&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   urlReporteGeografico:'https://app.powerbi.com/reportEmbed?reportId=6e1813d8-c134-4db1-8a4d-6c920b0fb04d&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   apiBIUrl: 'https://pactiaapiconexionbi.azurewebsites.net/api/',
// };

/*******CALIDAD*********/

// export const environment = {
//   production: true,
//   baseUrl: 'https://registroventasqa.pactia.com/service/api/',
//   baseUrlExterno: 'https://registroventasqa.pactia.com/service/',
//   scopeUri: ['api://356f480a-4226-4c9c-9144-e8cc70fe0456/RegistroVentasAPI'],
//   tenantId: '6503c5d1-70bc-437f-a0b6-a7849af8c68c',
//   uiClienId: '67585778-9a02-4897-b936-812a12e48d4b',
//   redirectUrl: 'https://registroventasqa.pactia.com/site/#/home',
//   userEmailLogged: '',
//   userFullname: '',
//   edificiosAutorizados: '',
//   marcasAutorizadas: '',
//   tipoUsuario: '',
//   userSubscripciónId: 0,
//   urlReporteCeco: 'https://app.powerbi.com/reportEmbed?reportId=7b092e8c-82c1-4684-b316-32d5a772a0ef&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   urlReporteGeneral: 'https://app.powerbi.com/reportEmbed?reportId=d2f6c44a-2b63-4d09-8df9-61cb20e0ad54&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   urlReporteGeografico:'https://app.powerbi.com/reportEmbed?reportId=6e1813d8-c134-4db1-8a4d-6c920b0fb04d&groupId=0f6677e4-5db7-4f28-9a93-157c503e0952&autoAuth=true&ctid=6503c5d1-70bc-437f-a0b6-a7849af8c68c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWNlbnRyYWwtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D',
//   apiBIUrl: 'https://pactiaapiconexionbi.azurewebsites.net/api/'
// };

